/**
 * Shared local-date helpers.
 *
 * Kept in one place so the page that *reads* a date-keyed query and the
 * prefetch layer that *warms* it compute the identical `yyyy-MM-dd` — a prefetch
 * with a drifting date would silently miss the cache and the spinner would come
 * back. Local time on purpose: a crew member's "today" is their wall clock.
 */
import { format, startOfDay, startOfWeek } from 'date-fns';

/** Today as a local `yyyy-MM-dd` — the dispatch board's day key. */
export function todayLocalISODate(date: Date = new Date()): string {
  return format(startOfDay(date), 'yyyy-MM-dd');
}

/** The Monday of `date`'s week as `yyyy-MM-dd` — the schedule grid's week key. */
export function mondayOfWeek(date: Date = new Date()): string {
  return format(startOfWeek(date, { weekStartsOn: 1 }), 'yyyy-MM-dd');
}
